import React, { useEffect } from "react";

import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setServiceType } from "src/store/sessionStore";
import eventBus from "src/utils/eventBus";

import sideIcon1 from "src/assets/i_side1.svg";
import sideIcon2 from "src/assets/i_side2.svg";
import sideIcon3 from "src/assets/i_side3.svg";
import sideIcon4 from "src/assets/i_side4.svg";
import sideIcon5 from "src/assets/i_side5.svg";
import sideIcon6 from "src/assets/i_side6.svg";
import sideIcon7 from "src/assets/i_side7.svg";
import sideIcon8 from "src/assets/i_side8.svg";

interface SidebarProps {
  isOpen: boolean;
  toggleSide: () => void;
}

const Sidebar: React.FC<SidebarProps> = ({ isOpen, toggleSide }) => {
  const dispatch = useDispatch();
  
  const clickMenu = ( service_type ) => {
    toggleSide()
    dispatch(setServiceType(service_type))
  }

  const handleOpenModal = () => {
    eventBus.emit("inquiryModal:show", { type: "success" });
  };

  useEffect(() => {
    if (isOpen) {
      window.history.pushState("sidebar-open", "", window.location.pathname); 
      
      const handleBackButton = () => {
        toggleSide(); 
      };

      window.addEventListener("popstate", handleBackButton);

      return () => {
        window.removeEventListener("popstate", handleBackButton);
      };
    }
  }, [isOpen, toggleSide]);


  return (
    <>
      {isOpen && <div className="overlay active" onClick={toggleSide}></div>}

      <div className={`sidebar ${isOpen ? "active" : ""}`}>
        <button className="btn-close" onClick={toggleSide} aria-label="Close"></button>
        <h3 className="fw-bold mt-5 mb-3">주식</h3>
        <ul className="list-unstyled">
          <li>
            <Link to="/post" className="d-block py-3 text-dark d-flex align-items-center gap-2" onClick={() => clickMenu("ST")}>
              <i><img src={sideIcon1} alt="인기게시글" /></i> 인기게시글
            </Link>
          </li>
          <li>
            <Link to="/ranking" className="d-block py-3 text-dark d-flex align-items-center gap-2" onClick={() => clickMenu("ST")}>
              <i><img src={sideIcon2} alt="랭킹" /></i> 랭킹
            </Link>
          </li>
          <li>
            <Link to="/stock" className="d-block py-3 text-dark d-flex align-items-center gap-2" onClick={() => clickMenu("ST")}>
              <i><img src={sideIcon3} alt="인기 종목" /></i> 인기 종목
            </Link>
          </li>
          <li>
            <Link to="/securitiescompany" className="d-block py-3 text-dark d-flex align-items-center gap-2" onClick={() => clickMenu("ST")}>
              <i><img src={sideIcon4} alt="" /></i> 증권사 채널
            </Link>
          </li>
          {/* <li>
            <Link to="/report" className="d-block py-3 text-dark d-flex align-items-center gap-2" onClick={() => clickMenu("ST")}>
              <i><img src={sideIcon5} alt="" /></i> HOT 리포트
            </Link>
          </li> */}
          <li>
            <Link to="/blog" className="d-block py-3 text-dark d-flex align-items-center gap-2" onClick={() => clickMenu("ST")}>
              <i><img src={sideIcon6} alt="" /></i> 핵심 블로그
            </Link>
          </li>
        </ul>

        <h3 className="fw-bold mt-5 mb-3">코인</h3>
        <ul className="list-unstyled">
          <li>
            <Link to="/post" className="d-block py-3 text-dark d-flex align-items-center gap-2" onClick={() => clickMenu("CO")}>
              <i><img src={sideIcon7} alt="인기게시글" /></i> 인기게시글
            </Link>
          </li>
          <li>
            <Link to="/ranking" className="d-block py-3 text-dark d-flex align-items-center gap-2" onClick={() => clickMenu("CO")}>
              <i><img src={sideIcon8} alt="랭킹" /></i> 랭킹
            </Link>
          </li>
        </ul>
        <div className="mt-4">
            <button className="btn btn-dark w-100 py-3" onClick={() => handleOpenModal()}>서비스 문의</button>
        </div>
      </div>
    </>
  );
};

export default Sidebar;
